import { render } from "./MessageRedeemDialog.vue?vue&type=template&id=eba4858e&scoped=true"
import script from "./MessageRedeemDialog.vue?vue&type=script&lang=js"
export * from "./MessageRedeemDialog.vue?vue&type=script&lang=js"

import "./MessageRedeemDialog.vue?vue&type=style&index=0&id=eba4858e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mahmoud\\Desktop\\Bugs\\Dubai Projects\\JC_2\\mongo-web\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eba4858e"]])

export default __exports__